import template from './employee_field_report.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeFieldReportViewModel
{
	constructor(page) {
		this.page = page;
		this.loader = ko.observable(false);

		this.employee_document_count_report = ko.observableArray('');
		this.employee_fields = ko.observable([]);
		this.additional_columns = ko.observableArray([]);
		this.selected_additional_column = ko.observableArray([]);
		this.department_selected = ko.observable(false);
		this.table_visible = ko.observable(false);
		this.selected_dep = ko.observable();
		this.current_department_id = ko.observable(null);
		this.include_resigned = ko.observable(false);

		// Add pagination observables
		this.sort_field = ko.observable('employee');
		this.sort_order = ko.observable('ASC');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(2);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([2, 20, 50, 100, 200]);
		this.selected_number_of_records = ko.observable(2);

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.updateData();
		});

		this.employee_document_count = ko.observable({
			department: ko.observable(),
			department_id: ko.observable(),
		});

		this.selected_dep.subscribe((val) => {
			if (val != null) {
				this.current_department_id(val.department_id);
				this.page.updateData();
			}
			else {
				this.current_department_id(null);
				this.page.updateData();
			}
		})

		this.include_resigned.subscribe((newText) => {
			this.page.updateData();
		});

		this.selected_additional_columns_text = ko.computed(() => {
			let selected_columns = this.selected_additional_column();
			if (!Array.isArray(selected_columns)) selected_columns = ko.unwrap(selected_columns);
			if (selected_columns.length === 0) return tr('View additional employee fields...');
			if (this.selected_additional_column().length > 3) return tr(`${selected_columns.length} additional columns selected`);
			
			return this.selected_additional_column().map(col => col.replace(/_/g, ' ')).join(', ');
		});
	}

	sort_column(column)
	{
		if (column && column.trim() !== '') {
			if (this.sort_field() === column) {
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			} else {
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.updateData();
		}
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	}

	toggle_selected_column(column) {
		if (this.selected_additional_column().includes(column)) {
			this.selected_additional_column.remove(column);
		} else {
			this.selected_additional_column.push(column);
		}
		this.page.updateData();
	}

	cell_formatter(value, row, index, field)
	{ 
		if (row.active === false)
			return `<span style="color:red">${value}</span>`;

		return value;
	}

	async btn_download_click()
	{
		try
		{
			let department_id = this.current_department_id();
		
			if (!department_id)
			{
				Grape.alerts.alert({ type: 'warning', title: 'Warning', message: 'Please select a department first' });
				this.loader(false);
				return;
			}

			let filter = [
				{
					value: department_id,
					operand: '=',
					field: 'department_id',
				}
			];

			if (!this.include_resigned())
			{
				filter.push({
					value: true,
					operand: '=',
					field: 'active'
				});
			}

			let res = await Grape.fetches.getJSON('/api/record', {
				schema: 'savanna',
				table: 'v_employee_field_report',
				filter: filter,
				sortfield: this.sort_field(),
				sortorder: this.sort_order()
			});

			if (!res.records || res.records.length === 0)
			{
				Grape.alerts.alert({ type: 'warning', title: 'Warning', message: 'No data to download' });
				this.loader(false);
				return;
			}

			// Now generate CSV with all the data
			let csv_content = 'data:text/csv;charset=utf-8,';
	
			// Get headers (including dynamic columns)
			let headers = ['Employee', 'Department', 'Contract Type'];
			ko.utils.arrayForEach(this.selected_additional_column(), function (column) {
				headers.push(column.replace(/_/g, ' '));
			});
			csv_content += headers.join(',') + '\r\n';
	
			// Process all fetched records (not just current page)
			let data = ko.utils.arrayMap(res.records, function (row)
			{
				let row_data = [
					row.active === false ?
						`${row.employee + '' + '(Resigned)' || ''}` : (row.employee || ''),
					row.active === false ?
						`${row.department || ''}` : (row.department || ''),
					row.active === false ?
						`${row.contract_type || ''}` : (row.contract_type || '')
				];
	
				// Add dynamic column data
				ko.utils.arrayForEach(this.selected_additional_column(), function (column)
				{
					let cell_value = row[column] || '';
					cell_value = cell_value.toString().replace(/"/g, '""');
					if (cell_value.includes(',') || cell_value.includes('"') || cell_value.includes('\n'))
						cell_value = `"${cell_value}"`;

					row_data.push(cell_value);
				}, this);
	
				return row_data.join(',');
			}, this);
	
			csv_content += data.join('\r\n');
	
			// Create the download link
			let encodedUri = encodeURI(csv_content);
			let link = document.createElement('a');
			link.setAttribute('href', encodedUri);
			link.setAttribute('download', 'employee_field_report.csv');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

		}
		catch (error)
		{
			console.error('Error downloading report:', error);
			alert('Error occurred while downloading the report');
		}
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeFieldReportHelp', { employee_id: this.page.bindings.id });
	}
}

class ReportEmployeeField
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeFieldReportViewModel(this);
	}

	async updateData()
	{
		this.viewModel.table_visible(false);
	
		if (await Utils.redirectOnAccessDenied('EmployeeDocumentCountReport'))
			return;
	
		let department_id = this.viewModel.current_department_id();
	
		if (!department_id)
		{
			this.viewModel.employee_fields([]);
			this.viewModel.department_selected(false);
			return;
		}

		this.viewModel.table_visible(true);
		this.viewModel.loader(true);
	
		let filter = [
			{
				value: department_id,
				operand: '=',
				field: 'department_id',
			}
		];

	
		if (!this.viewModel.include_resigned())
		{
			filter.push(
				{
					value: true,
					operand: '=',
					field: 'active'
				}
			);
		}
	
		let res = await Grape.fetches.getJSON('/api/record',
			{
				schema: 'savanna',
				table: 'v_employee_field_report',
				limit: this.viewModel.current_page_size(),
				offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
				filter: filter,
				sortfield: this.viewModel.sort_field(),
				sortorder: this.viewModel.sort_order()
			}
		);

		if (res.records)
		{
			this.viewModel.employee_fields(res.records);
			this.viewModel.page_count(Math.ceil(res.total / this.viewModel.current_page_size()));
			this.viewModel.pagination_summary(
				`Showing ${(this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1} to ${
					Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), res.total)
				} of ${res.total} entries`
			);
		}
	
		this.viewModel.loader(false);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeDocumentCountReport'))
			return;

		let res = await Grape.fetches.getJSON('/api/record',
			{
				schema: 'savanna',
				table: 'v_employee_field_report',
				limit: 1
			}
		);
	
		if (res.status !== 'ERROR' && res.records && res.records.length > 0)
		{
			// Get all column names except the default ones
			let excluded_fields = [
				'employee_id',
				'department_id',
				'company_id',
				'employee',
				'department',
				'contract_type',
				'active'
			];
	
			let column_names = [];
			for (let key in res.records[0])
			{
				if (!excluded_fields.includes(key))
				{
					column_names.push({
						field: key,
						display_name: key.replace(/_/g, ' ')
					});
				}
			}
			// Sort columns alphabetically by display name
			column_names.sort((a, b) => a.display_name.localeCompare(b.display_name));
				
			// Update the dropdown options
			this.viewModel.additional_columns(column_names);
		}	

		document.title = tr('Employee Fields Report');
		window.current_page_title(tr('Employee Fields Report'));
	}
};

export default {
	route: '[/]report/employee_field_report',
	page_class: ReportEmployeeField,
	template: template,
	template_filename: 'translation/employee_field_report',
};
